module.exports = (__parcel__import__("b238H")).then(() => parcelRequire('emu4l'));